import { z } from "zod";

const PaymentMethodsSchema = z
  .object({
    codi: z.number().optional().nullable(),
    spei: z.number().optional().nullable(),
    credit_card: z.number().optional().nullable(),
    cash_in: z.number().optional().nullable(),
    reference_code: z.number().optional().nullable(),
    cie: z.number().optional().nullable(),
  })
  .transform((api) => ({
    codi: api.codi === 1,
    spei: api.spei === 1,
    card: api.credit_card === 1,
    cash: api.cash_in === 1,
    tpvBarcode: api.reference_code === 1,
    cie: api.cie === 1,
  }));

type PaymentMethods = z.infer<typeof PaymentMethodsSchema>;

const PAYMENT_METHOD_PRIORITY = [
  "card",
  "cash",
  "spei",
  "cie",
  "tpvBarcode",
  "codi",
] as const;

type PaymentMethodKey = (typeof PAYMENT_METHOD_PRIORITY)[number];

const getEnabledPaymentMethods = (
  methods?: PaymentMethods,
): PaymentMethodKey[] =>
  methods ? PAYMENT_METHOD_PRIORITY.filter((key) => methods[key]) : [];

export {
  PaymentMethodsSchema,
  type PaymentMethods,
  type PaymentMethodKey,
  PAYMENT_METHOD_PRIORITY,
  getEnabledPaymentMethods,
};
